
import { Component, Ref } from 'vue-property-decorator'
import { Mixins } from 'vue-mixin-decorator'
import MixinInterface from '@/_mixins/index'
import ProjectMixin from '@/_mixins/project'

import Editor from '@/components/Editor/Editor.vue'
import PhoneInput from '@/_components/input/phone/phone.vue'

@Component({
    components: { Editor, PhoneInput },
    mixins: [ProjectMixin],
})
export default class ContactAdd extends Mixins<MixinInterface>(ProjectMixin) {
    dialog = true
    keepOpen = false

    // NAME
    name: any = ''
    nameRules = [(v: any) => !!v || this.getTranslation('fe_hse_module.error_name_required')]

    // NUMBER
    phoneNumber: any = ''
    phoneNumberIndex = Date.now()

    // DESCRIPTION
    tools = [
        'header',
        'linkTool',
        'list',
        'embed',
        'quote',
        'table',
        'delimiter',
        'Marker',
        'underline',
    ]
    description: any = null
    descriptionId = Date.now()

    passDescription(data: string) {
        this.description = data
    }

    // isPublic
    isPublic = false

    // POST
    @Ref('form') readonly form!: any
    valid = false
    loading = false

    async post() {
        if (!this.valid) {
            return
        }

        this.loading = true

        let data = {
            type: 'hseContact',
            attributes: {
                name: this.name,
                description: this.description,
                phoneNumber: this.phoneNumber,
                isPublic: this.isPublic,
            },
            relationships: {
                project: {
                    data: {
                        id: this.currentProjectId,
                        type: 'project',
                    },
                },
            },
        }

        try {
            let res = await this.postHSEContact(data)
            this.$emit('postContact', res)
            if (!this.keepOpen) {
                this.close()
            } else {
                this.form.resetValidation()
                this.name = ''
                this.phoneNumber = ''
                this.description = null
                this.descriptionId = Date.now()
                this.phoneNumberIndex = Date.now()
            }
        } catch (error) {
            this.$store.commit('setErrorSnackBar', {
                data: error.data.response.data.errors,
                text: this.$t('vbit_error.default_header'),
                url: `POST: ${this.url_project}/hseContacts`,
            })
        } finally {
            this.loading = false
        }
    }

    close() {
        this.$router.push({
            name: 'hse-contacts-settings',
            params: { projectId: this.$route.params.projectId },
        })
    }
}
